exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".car[data-v-0d543312]{pointer-events:none;position:absolute;bottom:0;left:0;z-index:20;top:270px;height:134px;width:134px}.smoke[data-v-0d543312]{animation:smoke-data-v-0d543312 1.5s infinite linear;display:block;height:40px;position:absolute;top:55px;left:-20px;transform:rotate(345deg)}@keyframes smoke-data-v-0d543312{0%{opacity:1}to{opacity:0;left:-30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d543312","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/components/MyProgress/Daccord/Car.vue
// module id = 876
// module chunks = 1